import { render, staticRenderFns } from "./FaceCapture.vue?vue&type=template&id=2dc92841&scoped=true"
import script from "./FaceCapture.vue?vue&type=script&lang=js"
export * from "./FaceCapture.vue?vue&type=script&lang=js"
import style0 from "./FaceCapture.vue?vue&type=style&index=0&id=2dc92841&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc92841",
  null
  
)

export default component.exports